module.exports = __webpack_public_path__ + "img/footer.c467aee9.png";